/**
     * @deprecated: Must be removed after statistics endpoint deprecated
     * Get the data of users and messages for Home page.
     */
export class StatisticsService2 {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        this.MessagingHubService = MessagingHubService;
        this.BASE_URI = '/statistics';
        this.INTERVAL_DAILY = 'D';
        this.INTERVAL_MONTHLY = 'M';
        this.INTERVAL_NO_INERVAL = 'NI';
        this.AGGREGATION_TYPE_RECEIVED_BY = 'Received';
        this.AGGREGATION_TYPE_SENT_BY = 'Sent';
    }
    getUserStatistics(interval, startDate, endDate) {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            to: 'postmaster@analytics.msging.net',
            uri: `${this.BASE_URI}/users/${interval}?startDate=${startDate}&endDate=${endDate}`,
        });
    }
    getMessagesStatistics(interval, aggregationType, startDate, endDate) {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            to: 'postmaster@analytics.msging.net',
            uri: `${this.BASE_URI}/messages/${interval}?startDate=${startDate.toString()}&endDate=${endDate.toString()}&aggregationType=${aggregationType}`,
        });
    }
}
StatisticsService2.$inject = ['MessagingHubService'];
